import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as Sentry from "@sentry/angular";
import { environment } from "src/environments/environment";

@Injectable()
export class SentryCustomErrorHandler extends Sentry.SentryErrorHandler {
  private isProduction: boolean;

  constructor(private snackBar: MatSnackBar) {
    /**
     * Pass options to Sentry's ErrorHandler here.
     * - showDialog: Show Sentry feedback dialog (only in dev for testing)
     * - logErrors: Log errors to console (always in dev, never in prod)
     */
    const isProduction = environment.production;
    super({ showDialog: false, logErrors: !isProduction });
    this.isProduction = isProduction;
  }

  handleError(error: any): void {
    // Always log errors in development
    if (!this.isProduction) {
      console.error("Error caught by handler:", error);
    }

    // Show user-friendly message
    this.snackBar.open("Something went wrong. We're looking into it.", 'OK', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center'
    });

    // Only send to Sentry in production (Sentry.init already handles this, but double-check)
    if (this.isProduction) {
    super.handleError(error);
    }
  }
}
